export const getCurrentPositionFactory = (navigator: any) => {
  const getCurrentPosition = (options: any) => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
  };

  return getCurrentPosition;
};
